// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IForfeitureSummaryRecordDto
 */
export interface IForfeitureSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IForfeitureSummaryRecordDto
     */
    plan_type?: string;
    /**
     * 
     * @type {number}
     * @memberof IForfeitureSummaryRecordDto
     */
    accounts_forfeited?: number;
    /**
     * 
     * @type {number}
     * @memberof IForfeitureSummaryRecordDto
     */
    amount_forfeited?: number;
    /**
     * 
     * @type {number}
     * @memberof IForfeitureSummaryRecordDto
     */
    contributed_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IForfeitureSummaryRecordDto
     */
    ineligible_claim_count?: number;
    /**
     * 
     * @type {number}
     * @memberof IForfeitureSummaryRecordDto
     */
    ineligible_claim_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IForfeitureSummaryRecordDto
     */
    rollover_in?: number;
    /**
     * 
     * @type {number}
     * @memberof IForfeitureSummaryRecordDto
     */
    rollover_out?: number;
}

/**
 * Check if a given object implements the IForfeitureSummaryRecordDto interface.
 */
export function instanceOfIForfeitureSummaryRecordDto(value: object): value is IForfeitureSummaryRecordDto {
    return true;
}

export function IForfeitureSummaryRecordDtoFromJSON(json: any): IForfeitureSummaryRecordDto {
    return IForfeitureSummaryRecordDtoFromJSONTyped(json, false);
}

export function IForfeitureSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IForfeitureSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_type': json['plan_type'] == null ? undefined : json['plan_type'],
        'accounts_forfeited': json['accounts_forfeited'] == null ? undefined : json['accounts_forfeited'],
        'amount_forfeited': json['amount_forfeited'] == null ? undefined : json['amount_forfeited'],
        'contributed_amount': json['contributed_amount'] == null ? undefined : json['contributed_amount'],
        'ineligible_claim_count': json['ineligible_claim_count'] == null ? undefined : json['ineligible_claim_count'],
        'ineligible_claim_amount': json['ineligible_claim_amount'] == null ? undefined : json['ineligible_claim_amount'],
        'rollover_in': json['rollover_in'] == null ? undefined : json['rollover_in'],
        'rollover_out': json['rollover_out'] == null ? undefined : json['rollover_out'],
    };
}

export function IForfeitureSummaryRecordDtoToJSON(json: any): IForfeitureSummaryRecordDto {
    return IForfeitureSummaryRecordDtoToJSONTyped(json, false);
}

export function IForfeitureSummaryRecordDtoToJSONTyped(value?: IForfeitureSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_type': value['plan_type'],
        'accounts_forfeited': value['accounts_forfeited'],
        'amount_forfeited': value['amount_forfeited'],
        'contributed_amount': value['contributed_amount'],
        'ineligible_claim_count': value['ineligible_claim_count'],
        'ineligible_claim_amount': value['ineligible_claim_amount'],
        'rollover_in': value['rollover_in'],
        'rollover_out': value['rollover_out'],
    };
}

